const equipmentMasterColumns = () => {
  return (
    [
      {
        Header: 'Display Sequence',
        accessor: 'displayseq',
        editType: 'number',
        options: []
      },


      {
        Header: 'Equipment Id',
        accessor: 'equipmentcode',
        editType: 'inputField',
        options: []
      },
      {
        Header: 'Name',
        accessor: 'equipmentname',
        editType: 'inputField',
        options: []
      },
      {
        Header: 'Description',
        accessor: 'equipmentdescription',
        editType: 'inputField',
        options: []
      },
      {
        Header: 'Drawing No. ',
        accessor: 'drawingno',
        editType: 'inputField',
        options: []
      },

      {
        Header: 'Active ?',
        accessor: 'isactive',
        editType: 'Boolean',
        options: []
      },
      {
        Header: 'Remarks',
        accessor: 'remarks',
        editType: 'inputField',
        options: []
      }

    ]
  )
}

export default equipmentMasterColumns ;
